import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";

const AddPartForm = forwardRef(({ onAdd, initialData }, ref) => {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    device: "",
    model: "",
    brand: "",
    price: "",
    stock: "",
    description: "",
    image: null,
  });

  // ================= PREFILL FOR EDIT =================
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        category: initialData.category || "",
        device: initialData.device || "",
        model: initialData.model || "",
        brand: initialData.brand || "",
        price: initialData.price || "",
        stock: initialData.stock || "",
        description: initialData.description || "",
        image: null,
      });
    }
  }, [initialData]);

  // ================= RESET =================
  useImperativeHandle(ref, () => ({
    resetForm() {
      setFormData({
        name: "",
        category: "",
        device: "",
        model: "",
        brand: "",
        price: "",
        stock: "",
        description: "",
        image: null,
      });
    },
  }));

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setFormData((p) => ({
      ...p,
      [name]: name === "image" ? files[0] : value,
    }));
  };

  // ================= SUBMIT =================
  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();

    Object.keys(formData).forEach((k) => {
      data.append(k, formData[k]);
    });

    onAdd(data);
  };

  return (

     <div className="relative bg-white rounded-xl shadow ">

       <h2 className="text-xl font-bold mb-4 ml-[20px]">
          {initialData ? "Edito Pjese" : "Shto Pjese"}
        </h2>
    <form onSubmit={handleSubmit} className="p-5 space-y-3">

      <input
        name="name"
        value={formData.name}
        placeholder="Name"
        onChange={handleChange}
        className="w-full p-2 border rounded"
      />

      <input
        name="device"
        value={formData.device}
        placeholder="Device"
        onChange={handleChange}
        className="w-full p-2 border rounded"
      />

      <input
        name="category"
        value={formData.category}
        placeholder="Category"
        onChange={handleChange}
        className="w-full p-2 border rounded"
      />

      <input
        name="model"
        value={formData.model}
        placeholder="Model"
        onChange={handleChange}
        className="w-full p-2 border rounded"
      />

      <input
        name="brand"
        value={formData.brand}
        placeholder="Brand"
        onChange={handleChange}
        className="w-full p-2 border rounded"
      />

      <input
        name="price"
        value={formData.price}
        placeholder="Price"
        onChange={handleChange}
        className="w-full p-2 border rounded"
      />

      <input
        name="stock"
        value={formData.stock}
        placeholder="Stock"
        onChange={handleChange}
        className="w-full p-2 border rounded"
      />

      <textarea
        name="description"
        value={formData.description}
        onChange={handleChange}
        placeholder="Description"
        className="w-full p-2 border rounded"
      />

      <input type="file" name="image" onChange={handleChange} />

      <button className="w-full bg-blue-600 text-white py-2 rounded">
        {initialData ? "Modifiko Pjese" : "Shto Pjese"}
      </button>
    </form>
    </div>
  );
});

export default AddPartForm;